import React, {useState} from "react";

export const CommunityFeedContext = React.createContext({});

export const CommunityFeedProvider = (props: any) => {
  const [user, setUser] = useState(null);
  const [feeds, setFeeds] = useState(null);
  const [hasMorePost, setHasMorePost] = useState(true);
  const [isDisablePostBtn, setIsDisablePostBtn] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [tag, setTag] = useState([]);
  const [category, setCategory] = useState([]);
  const [privacyOption, setPrivacyOption] = useState(null);
  const [fileValue, setFileValue] = useState(null);
  const [previewCovers, setPreviewCovers] = useState(null);
  const [fileCovers, setFileCovers] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [showModalCreatePost, setShowModalCreatePost] = useState(false);
  const [showModalCheckCancel, setShowModalCheckCancel] = useState(false);
  const [currentPost, setCurrentPost]: any = useState(null);
  const [isEditPost, setIsEditPost]: any = useState(false);
  const [postID, setPostID]: any = useState(null);
  const [oldData, setOldData]: any = useState(null);
  const [captionStyle, setCaptionStyle]:any = useState(null);
  const [oldcover, setOldcover]: any = useState(null);

  const [userId, setUserId] = useState<string>("");

  const state = {
    user: user,
    setUser: setUser,
    feeds: feeds,
    setFeeds: setFeeds,
    hasMorePost: hasMorePost,
    setHasMorePost: setHasMorePost,
    isDisablePostBtn: isDisablePostBtn,
    setIsDisablePostBtn: setIsDisablePostBtn,
    title: title,
    setTitle: setTitle,
    content: content,
    setContent: setContent,
    privacyOption: privacyOption,
    setPrivacyOption: setPrivacyOption,
    fileValue: fileValue,
    setFileValue: setFileValue,
    previewCovers: previewCovers,
    setPreviewCovers: setPreviewCovers,
    fileCovers: fileCovers,
    setFileCovers: setFileCovers,
    confirmLoading: confirmLoading,
    setConfirmLoading: setConfirmLoading,
    showModalCreatePost: showModalCreatePost,
    setShowModalCreatePost: setShowModalCreatePost,
    showModalCheckCancel: showModalCheckCancel,
    setShowModalCheckCancel: setShowModalCheckCancel,
    tag: tag,
    setTag: setTag,
    category: category,
    setCategory: setCategory,
    oldcover: oldcover,
    setOldcover: setOldcover,
    currentPost,
    setCurrentPost,
    isEditPost,
    setIsEditPost,
    postID,
    setPostID,
    oldData,
    setOldData,
    captionStyle,
    setCaptionStyle,
    userId,
    setUserId
  };
  return (
    <CommunityFeedContext.Provider value={state}>
      {props.children}
    </CommunityFeedContext.Provider>
  );
};
//@ts-ignore
CommunityFeedProvider.Consumer = CommunityFeedContext.Consumer;
